/**
 * Type definitions for lecture registration form
 */

export const STEP_IDS = {
  // Main steps
  INFORMATION: 'information',
  LECTURE_TYPE: 'lecture_type',
  
  // Detail substeps
  GENERAL_CONDITIONS: 'general_conditions',
  TITLE: 'title',
  LANGUAGE: 'language',
  TOPICS: 'topics',
  SPEAKERS: 'speakers',
  DESCRIPTION: 'description',
  SUBJECTS: 'subjects',
  IMAGE: 'image',
  HANDOUT: 'handout',
  PRESENTATION: 'presentation',
  
  // Final steps
  MARKETING: 'marketing',
  REVIEW: 'review'
};

export const MAIN_STEP_IDS = {
  INFORMATION: 'information',
  GENERAL_CONDITIONS: 'general_conditions',
  LECTURE_TYPE: 'lecture_type',
  DETAILS: 'details',
  MARKETING: 'marketing',
  REVIEW: 'review'
};

export const LANGUAGES = {
  DE: 'de',
  EN: 'en'
};

export const LECTURE_CATEGORIES = {
  TECHNICAL: 'technical',
  MARKETING: 'marketing',
  EDUCATIONAL: 'educational'
};

export const ARRANGEMENT_TYPES = {
  PRESENTATION: 'presentation',
  WORKSHOP: 'workshop',
  PANEL: 'panel'
};

// Initial form data structure
export const INITIAL_FORM_DATA = {
  // General section
  type: '',
  generalConditions: [],
  conditions: [],
  speakers: [],
  language: '',
  
  // Details section
  title: '',
  description: '',
  subjects: [],
  topics: [],
  image: null,
  handout: null,
  presentation: null,
  
  // User interaction tracking
  hasReadInformation: false,
  
  // Meta information
  isValid: false,
  completedSteps: [],
  currentStep: STEP_IDS.INFORMATION
};

// Legacy validation rules - now replaced by dynamic configuration in stepsConfig.js
// This is kept for backwards compatibility but should be removed once all validation is migrated
export const VALIDATION_RULES = {
  // Validation rules are now defined in stepsConfig.js within each step's validationRules property
  // Use getValidationRulesForStep(stepsConfig, stepId) to get validation rules dynamically
};